export function camelCase (str) {
  str = str.replace(/-(\w)/ig, function () {
    return arguments[1].toUpperCase()
  })
  return str
}
